<button kendoButton (click)="this.isShowing = true">PDF</button>
<kendo-dialog *ngIf="this.isShowing" width="1700px" (close)="this.isShowing = false">
    <kendo-dialog-titlebar>
        PDF        
    </kendo-dialog-titlebar>
    <hdw-pdf/>
    <kendo-dialog-actions>
        <button kendoButton (click)="this.isShowing = false" themeColor="primary">Close</button>
    </kendo-dialog-actions>

</kendo-dialog>